/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Detail_No_Slots_SubtitleInputs */

const en_job_detail_no_slots_subtitle = /** @type {(inputs: Job_Detail_No_Slots_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create available slots to accept applications and book interviews.`)
};

const de_job_detail_no_slots_subtitle = /** @type {(inputs: Job_Detail_No_Slots_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legen Sie verfügbare Termine an, damit Sie Bewerbungen annehmen und Gespräche buchen können.`)
};

/**
* | output |
* | --- |
* | "Create available slots to accept applications and book interviews." |
*
* @param {Job_Detail_No_Slots_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_detail_no_slots_subtitle = /** @type {((inputs?: Job_Detail_No_Slots_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Detail_No_Slots_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_detail_no_slots_subtitle(inputs)
	return en_job_detail_no_slots_subtitle(inputs)
});